import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import ConnectionBanner from "@/components/ConnectionBanner";
import { Toaster } from "@/components/ui/sonner";

import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import RecuperarPasswordPage from "@/pages/RecuperarPasswordPage";
import RestablecerPasswordPage from "@/pages/RestablecerPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import AgendaPage from "@/pages/AgendaPage";
import ReservasPage from "@/pages/ReservasPage";
import BandejaPage from "@/pages/BandejaPage";
import ReportesPage from "@/pages/ReportesPage";
import AgenteWhatsAppPage from "@/pages/AgenteWhatsAppPage";
import PreguntasTipicasPage from "@/pages/PreguntasTipicasPage";
import ConfiguracionPage from "@/pages/config/ConfiguracionPage";
import PortalLayout from "@/components/layout/PortalLayout";
import PortalDisponibilidad from "@/pages/portal/PortalDisponibilidad";
import PortalNuevaReserva from "@/pages/portal/PortalNuevaReserva";
import PortalReservas from "@/pages/portal/PortalReservas";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConnectionBanner />
        <BrowserRouter>
          <ErrorBoundary>
            <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* PROMPT 96: recuperar la contraseña. Van SIN login, igual que /login. */}
            <Route path="/recuperar" element={<RecuperarPasswordPage />} />
            <Route path="/restablecer/:token" element={<RestablecerPasswordPage />} />
            <Route
              path="/cambiar-password"
              element={
                <ProtectedRoute>
                  <ChangePasswordPage />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute roles={["admin", "operador"]}>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/agenda" element={<AgendaPage />} />
              <Route path="/reservas" element={<ReservasPage />} />
              <Route path="/bandeja" element={<BandejaPage />} />
              <Route path="/reportes" element={<ReportesPage />} />
              <Route path="/agente" element={<AgenteWhatsAppPage />} />
              {/* PROMPT 132: las preguntas típicas del agente (agregar, ordenar por tema y marca, cargar muchas). */}
              <Route path="/preguntas" element={<PreguntasTipicasPage />} />
              <Route
                path="/configuracion"
                element={
                  <ProtectedRoute requireAdmin>
                    <ConfiguracionPage />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              element={
                <ProtectedRoute roles={["agencia"]}>
                  <PortalLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/portal" element={<PortalDisponibilidad />} />
              <Route path="/portal/nueva" element={<PortalNuevaReserva />} />
              <Route path="/portal/reservas" element={<PortalReservas />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
